<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">默认模板添加</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="addForm" :rules="rules" ref="addForm" label-width="80px">
                    <div>
                        <el-row>
                            <el-col :span="22" class="item">
                                <el-form-item label="模板分类" required>
                                    <el-select v-model="addForm.printClassCode" filterable placeholder="请选择">
                                        <el-option
                                        v-for="item in list"
                                        :key="item.printClassCode"
                                        :label="item.name"
                                        :value="item.printClassCode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form>
            </div>
            <div class="modal-footer">
                <el-button :loading="loading"  type="primary" @click="confirm('addForm')">添加</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Add',
        data() {
            return {
                loading: false,
                list:[],
                addForm:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    printClassCode:"",
                },
                
                rules:{
                    name:[
                        { required: true, message: '请输入名称', trigger: 'blur' },
                    ],
                },

            }
        },

        methods: {

            init(){
                this.getPrintClassList();
            },
            getPrintClassList(){
                 this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"PrintClass/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        console.log(response.data);
                        this.list = response.data.data;
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },

            closeSelf() {
                this.$emit("closeAdd");
            },

            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if (valid) {
                        if(this.addForm.printClassCode==""){
                            this.$message("分类不能为空");
                            return;
                        }
                        this.addSubmit();
                        
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });

            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"PrintItem/Add",
                    data: this.addForm
                }).then(
                    (response) => {
                        console.log(response);
                        this.loading = false;

                        if (response.data.error == 0) {
                            this.$emit("closeAdd");
                            this.$emit("getList");
                        } else {
                            this.$message({type: 'info', message: response.data.message});
                        }

                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow: 2px 2px 20px 1px;
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                overflow-y:scroll;
                height: auto;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }

    /deep/ .el-upload-dragger {
        width: 405px;
    }

    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
